module.exports = __webpack_public_path__ + "img/myVip_bg_new.915fee69.png";